import { Scan } from 'lucide-react';
import { useIntl } from 'react-intl';
import ToolbarButton from '~/components/toolbar/shared/ToolbarButton';
import { useSeriesOverview } from '~/hooks/viewer/useSeriesOverview';

/**
 * Shows or hides the series overview of the primary image, a panel that
 * hangs on the primary row. Pressed while the overview is shown; disabled
 * with no primary image, which the overview would project.
 */
export default function SeriesOverviewTool() {
    const intl = useIntl();
    const { isOpen, image, toggle } = useSeriesOverview();

    return (
        <ToolbarButton
            icon={<Scan />}
            tooltip={intl.formatMessage({ id: 'series.mipPreview' })}
            selected={isOpen}
            ariaPressed={isOpen}
            disabled={image === undefined}
            onClick={toggle}
            data-testid="series-mip-preview-button"
        />
    );
}
